import { mergeDuplicatesTerms } from '../../js/services/CommonUtility';
import * as actiontypes from '../types';
import axios from 'axios';
export const InventoryFilterSettings = {
  state: {
    selectedFilters: {},
    filtersData: {},
    selectedFiltersUrl: {},
    showFilterLoading: false,
    filterLoading: false,
    currentFilterUrl: window.location.href,
    currentfilterdropdownselected: '',
    filtersCountValue: '',
    filtersCountValueOnPopUp: '',
    defaultSelectedObj: {
      accountID: window.accountId,
      campaignID: window.campaignId,
      comment1: null,
      comment2: null,
      comment3: null,
      comment4: null,
      downPayment: 0,
      driveTrains: null,
      dueAtSigning: 0,
      engines: null,
      featureSubCategories: null,
      fuelTypes: null,
      isCertified: true,
      locations: '',
      makes: '',
      masterTemplateId: window.masterTemplateId,
      mileageMax: 0,
      mileageMin: 0,
      models: '',
      noCache: false,
      oneOwner: false,
      paymentMax: 0,
      paymentMin: 0,
      paymentType: '',
      reserveYourVehicleLink: '',
      selectedNavText: '',
      sortType: 'priceltoh',
      specialFeild3: null,
      transmissions: null,
      trims: '',
      type: 'New',
      vehicleTypes: null,
      years: '',
    },
    showEvnVideoModel: false,
    vinRealVideoId: '',
    conditionalRebatesDisclaimer: {
      disclaimer: '',
      showModel: false,
    },
    showConditionalRebatesDisclaimerModel: false,
    inventoryApiCallCounter: 0,
    isMultiSelect:
      window.srpFilterPosition?.toLowerCase() === 'topmultiselect' ||
      window.srpFilterPosition?.toLowerCase() === 'leftmultiselect',
    selectedFilterData: {},
    showFilterValidationModal: false,
  },

  mutations: {
    setfiltersettings(state, payload) {
      state.selectedFilters = payload.selectedFilters;
      let filterLoads = payload.filters;
      filterLoads.trims = mergeDuplicatesTerms(payload.filters.trims);
      state.filtersData = filterLoads;
      state.selectedFiltersUrl = payload.selectedFiltersUrl;
    },
    applyfiltersB(state, payload) {
      let type = state.selectedFilters['type'];
      let paymentType = state.selectedFilters['paymentType'];
      let inventoryUrlObj = {};
      inventoryUrlObj['make'] = state.selectedFilters['makes'];
      inventoryUrlObj['model'] = state.selectedFilters['models'];
      inventoryUrlObj['trim'] = state.selectedFilters['trims'];
      inventoryUrlObj['years'] = state.selectedFilters['years'];
      inventoryUrlObj['locations'] = state.selectedFilters['locations'];
      inventoryUrlObj['colors'] = state.selectedFilters['exteriorColors'];
      inventoryUrlObj['fuelTypes'] = state.selectedFilters['fuelTypes'];
      inventoryUrlObj['transmissions'] = state.selectedFilters['transmissions'];
      inventoryUrlObj['driveTrains'] = state.selectedFilters['driveTrains'];
      inventoryUrlObj['engines'] = state.selectedFilters['engines'];
      inventoryUrlObj['paymentMax'] = state.selectedFilters['paymentMax'];
      inventoryUrlObj['paymentMin'] = state.selectedFilters['paymentMin'];

      let inventoryUrl = `${window.baseUrl}/inventory/${type}?paymenttype=${paymentType}`;

      Object.entries(inventoryUrlObj).forEach(([key, value]) => {
        if (value) {
          const checkForKeys = ['make', 'model', 'trim'];

          if (checkForKeys.includes(key.toLowerCase())) {
            value = value.replaceAll(' ', '-');
          }

          inventoryUrl = inventoryUrl.concat(`&${key.toLowerCase()}=${value}`);
        }
      });
      window.location.href = inventoryUrl;
    },
    applyfilters(state, payload) {
      let urlString;
      if (state.currentFilterUrl) {
        urlString = state.currentFilterUrl;
      } else {
        urlString = `${window.baseUrl}/inventory/`;
      }
      let isIframe = window.location !== window.parent.location;
      if (isIframe && window.showFilters === 'True') {
        if (urlString.includes('?')) {
          urlString = urlString + '&showfilters=true';
        } else {
          urlString = urlString + '?showfilters=true';
        }
      }
      window.location.href = urlString;
    },
    setloading(state, payload) {
      state.showFilterLoading = payload;
    },
    setFilterLoading(state, payload) {
      state.filterLoading = payload;
    },
    setcurrentfilterurl(state, payload) {
      if (payload.indexOf('used') && window.usePreownedRouteForUsed) {
        payload = payload.replace('used', 'pre-owned');
      }
      state.currentFilterUrl = payload;
    },
    setcurrentfilterdropdownselected(state, payload) {
      state.currentfilterdropdownselected = payload;
    },
    setFiltersCount(state, payload) {
      state.filtersCountValue = payload;
    },
    setFiltersCountPopUp(state, payload) {
      state.filtersCountValueOnPopUp = payload;
    },
    setShowEvnVideoModal(state, payload) {
      state.showEvnVideoModel = payload;
    },
    setVinRealVideoId(state, payload) {
      state.vinRealVideoId = payload;
    },
    showRebatesDisclaimerModel(state, payload) {
      state.conditionalRebatesDisclaimer = payload;
    },
    setSelectedFilterData(state, payload) {
      state.selectedFilterData = payload;
    },
    setFilterValidationModal(state, payload) {
      state.showFilterValidationModal = payload;
    },
  },
  actions: {
    [actiontypes.GET_FILTERS_SETTINGS](context, payload) {
      let payloadObj = { ...payload };
      try {
        if ('Page' in payloadObj) {
          delete payloadObj?.Page;
        } else {
          delete payloadObj?.page;
        }
      }catch(e) {
        console.log(e);
      }

      // exclude page param from selected URL
      try{
      const selectedUrlObj = new URL(context.state.currentFilterUrl);
      selectedUrlObj.searchParams.delete('page');
      selectedUrlObj.searchParams.delete('Page');
      payloadObj.selectedUrl = selectedUrlObj.toString();
      }
      catch(e) {
        console.log(e);
      }
      payloadObj['IsShowRoomPage'] = !!window.isShowRoomPage;

      if (
        (window.srpFilterPosition?.toLowerCase() === 'top' ||
          window.srpFilterPosition?.toLowerCase() === 'left') &&
        context.state.inventoryApiCallCounter
      ) {
        window.location.href = context.state.currentFilterUrl;
        return;
      }
      context.state.inventoryApiCallCounter++;
      let url = `${window.ApiBaseUrl}/Inventory/getinventorymultiselectionfilters`;
      const params = new URLSearchParams(document.location.search).get('fetchdatafrom');
      if (!payloadObj.isLoading) {
        context.commit(actiontypes.SET_LOADING, true);
      }
      context.commit(actiontypes.SET_FILTER_LOADING, true);
      // Enable "enableSRPFiltersGetApi" window variable to use new API. This condition will be removed and only new api will be used later.
      if (window.enableSRPFiltersGetApi) {
        url = `${window.ApiBaseUrl}/Inventory/getinventorymultiselectionfilters/v2`;
        const finalPayload = { ...payloadObj };

        const propertiesToRemove = [
          'CampaignId',
          'AccountID',
          'MasterTemplateId',
          'SelectedNavText',
          'ReserveYourVehicleLink',
          'selectedUrl',
          'selectedNavText',
          'isLoading',
        ];
        for (const prop in finalPayload) {
          if (
            !finalPayload[prop] ||
            propertiesToRemove.map((o) => o.toLowerCase()).includes(prop.toLowerCase())
          ) {
            delete finalPayload[prop];
          }
        }
        const queryString = new URLSearchParams(finalPayload).toString();
        url += params ? '?fetchdatafrom=' + params + '&' + queryString : '?' + queryString;
        axios
          .get(url)
          .then((response) => {
            context.commit('setfiltersettings', response.data);
            context.commit(actiontypes.SET_LOADING, false);
            context.commit(actiontypes.SET_FILTER_LOADING, false);
          })
          .catch((err) => {
            console.log(err);
            context.commit(actiontypes.SET_LOADING, false);
            context.commit(actiontypes.SET_FILTER_LOADING, false);
          });
      } else {
        url += params ? '?fetchdatafrom=' + params : '';
        axios
          .post(url, payloadObj)
          .then((response) => {
            context.commit('setfiltersettings', response.data);
            context.commit(actiontypes.SET_LOADING, false);
            context.commit(actiontypes.SET_FILTER_LOADING, false);
          })
          .catch((err) => {
            console.log(err);
            context.commit(actiontypes.SET_LOADING, false);
            context.commit(actiontypes.SET_FILTER_LOADING, false);
          });
      }
    },
  },
};
